import React, {ReactNode} from "react";
import {EventType} from "data/types";

const DetailPagetLayout = ({
  children,
  event,
}: {
  children: ReactNode;
  event?: EventType;
}) => {
  return (
    <div className="ListingDetailPage">
      <div className="container ListingDetailPage__content">{children}</div>
    </div>
  );
};

export default DetailPagetLayout;
